var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Cookie } from '@mediaflowcom/mf-js-utils';
import { html, LitElement } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import '../video-item/video-item';
import '../video-list/video-list';
import styles from './search.styles';
import { dictionary } from '@mf-cms/helpers';
import '@mf-cms/components/src/skeleton/skeleton';
let PSearch = class PSearch extends LitElement {
    constructor() {
        super(...arguments);
        this.videoBaseUrl = '';
        this.culture = 'en-GB';
        this.showRuntime = false;
        this.showDate = false;
        this.type = '';
        this.results = {
            items: [],
            totalHits: 0
        };
    }
    static { this.styles = styles; }
    /**
     * Search for videos or pages
     * @returns {void}
     */
    async search() {
        if (!this.query) {
            return;
        }
        this.loading = true;
        // Fetch search results
        this.results = await this.fetchSearchResults();
        this.loading = false;
        // Dispatch search event for analytics
        window.dispatchEvent(new CustomEvent('action', {
            detail: {
                type: 'search',
                query: this.query,
                hits: this.results.totalHits,
                culture: this.culture
            }
        }));
    }
    /**
     * Fetch search results from API based on type
     * @returns {Promise<{ items: any[], totalHits: number }>} Search results
     */
    async fetchSearchResults() {
        const accessToken = Cookie.get('portal_access_token');
        // Search videos
        if (this.type == 'video') {
            const response = await fetch(`${process.env.API_URL}/search/file?fields=any&access_token=${accessToken}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    searchTerm: this.query,
                    fileTypes: ['video']
                })
            });
            const json = await response.json();
            return { items: json, totalHits: json.length };
        }
        // Search pages
        const response = await fetch(`/api/pages/search?q=${this.query}&culture=${this.culture}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await response.json();
        return { items: json.items, totalHits: json.totalHits };
    }
    /**
     * On created
     * @returns {void}
     */
    async firstUpdated() {
        await this.search();
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        if (this.type == 'video') {
            return html ` <section id="search" class="search"> <div class="container"> <h1>${dictionary(this.culture, 'search', 'searchResult', [this.query])}</h1> ${this.loading ? html `
                  <ul class="results" aria-label=${dictionary(this.culture, 'search', 'loading')}>
                    <li><p-video-item preview ?dark=${this.dark}></p-video-item></li>
                    <li><p-video-item preview ?dark=${this.dark}></p-video-item></li>
                    <li><p-video-item preview ?dark=${this.dark}></p-video-item></li>
                    <li><p-video-item preview ?dark=${this.dark}></p-video-item></li>
                  </ul>
                `
                : html ` <ul class="results" aria-label=${dictionary(this.culture, 'search', 'results')}> ${this.results.items?.map((result) => html `
                        <li>
                          <p-video-item
                            heading-tag="h2"
                            culture=${this.culture}
                            class="result"
                            poster=${result.poster}
                            heading=${result.name}
                            duration=${this.showRuntime ? result.length : ''}
                            date=${this.showDate ? result.uploaded : ''}
                            link="${this.videoBaseUrl}/${result.id}"
                          >
                          </p-video-item>
                        </li>
                      `)}
                  </ul>
                  ${this.results.totalHits === 0
                    ? html `<p class="empty">${dictionary(this.culture, 'search', 'noResults')}</p>`
                    : ''}
                `}
          </div>
        </section>
      `;
        }
        return html ` <section id="search" class="search"> <div class="container pages-container"> <h1>${dictionary(this.culture, 'search', 'searchResult', [this.query])}</h1> <div class="files-result"> <h2>${dictionary(this.culture, 'search', 'files')}</h2> <p-files enable-search search-query=${this.query} sort="name" sort-order="asc" layout="grid" padding="none" hide-header show-size show-dimensions show-type loading-items="3" ></p-files> </div> ${this.loading ? html `
                    <h2>${dictionary(this.culture, 'search', 'pages')}</h2>
                    <ul
                      class="results list"
                      aria-label=${dictionary(this.culture, 'search', 'loading')}
                    >
                      <li>
                        <p-skeleton height="30px" width="40%" margin="20px"></p-skeleton>
                        <p-skeleton height="20px" width="70%"></p-skeleton>
                        <p-skeleton height="20px" width="50%" margin="0"></p-skeleton>
                      </li>
                      <li>
                        <p-skeleton height="30px" width="40%" margin="20px"></p-skeleton>
                        <p-skeleton height="20px" width="70%"></p-skeleton>
                        <p-skeleton height="20px" width="50%" margin="0"></p-skeleton>
                      </li>
                      <li>
                        <p-skeleton height="30px" width="40%" margin="20px"></p-skeleton>
                        <p-skeleton height="20px" width="70%"></p-skeleton>
                        <p-skeleton height="20px" width="50%" margin="0"></p-skeleton>
                      </li>
                      <li>
                        <p-skeleton height="30px" width="40%" margin="20px"></p-skeleton>
                        <p-skeleton height="20px" width="70%"></p-skeleton>
                        <p-skeleton height="20px" width="50%" margin="0"></p-skeleton>
                      </li>
                    </ul>
                  `
            : html ` <h2>${dictionary(this.culture, 'search', 'pages')}</h2> <ul class="results list" aria-label=${dictionary(this.culture, 'search', 'results')} > ${this.results.items?.map((result) => html `
                          <li>
                            <div>
                              <h3><a href=${result.url}>${result.title || result.name}</a></h2>
                              <p>${result.description}</p>
                            </div>
                          </li>
                        `)}
                    </ul>
                    ${this.results.totalHits === 0
                ? html `<p class="empty"> ${dictionary(this.culture, 'search', 'noResults')} </p>`
                : ''}
                  `}
          <div>
        </section>`;
    }
};
__decorate([
    property({ type: String, reflect: true })
], PSearch.prototype, "query", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PSearch.prototype, "loading", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PSearch.prototype, "dark", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'video-base-url' })
], PSearch.prototype, "videoBaseUrl", void 0);
__decorate([
    property({ type: String })
], PSearch.prototype, "culture", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'show-runtime' })
], PSearch.prototype, "showRuntime", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'show-date' })
], PSearch.prototype, "showDate", void 0);
__decorate([
    property({ type: String })
], PSearch.prototype, "type", void 0);
__decorate([
    property()
], PSearch.prototype, "results", void 0);
__decorate([
    query('#search')
], PSearch.prototype, "searchEl", void 0);
PSearch = __decorate([
    customElement('p-search')
    /**
     * PSearch component
     *
     * @class PSearch
     * @typedef {PImage}
     * @extends {LitElement}
     */
], PSearch);
export { PSearch };
